module.exports = __webpack_public_path__ + "static/media/Elite_Only.12ca8dae.jpg";